export default "__VITE_ASSET__DistVebz__"